
import * as _ from "lodash";
import "es6-promise";

import axios, { AxiosResponse } from "axios";
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";

import InputFilesForm from "../../../InputFilesForm.vue";
import PipelineParams from "./PipelineParams.vue";
import SelectGenome from "../../../SelectGenome.vue";

@Component({ components: { InputFilesForm, SelectGenome, PipelineParams } })
export default class RNASeqSetup extends Vue {
  // This is a string since vue-router only allows strings to be passed as params
  @Prop({ type: String, default: "false" })
  public allowSkipping: string;

  get dataSource_stepComplete(): boolean {
    return (
      this.$store.getters.sample_cart_count > 0 || this.allowSkipping === "true"
    );
  }

  _describeSamples_stepComplete: boolean = false;
  get describeSamples_stepComplete(): boolean {
    return this._describeSamples_stepComplete || this.allowSkipping === "true";
  }

  set describeSamples_stepComplete(state: boolean) {
    this._describeSamples_stepComplete = state;
  }

  get selectGenome_stepComplete(): boolean {
    return (
      this.allowSkipping === "true" || this.$store.get("genome_values_valid")
    );
  }

  public start_job_button_enabled = true;
  get pipelineSettings_stepComplete(): boolean {
    return this.$store.state.pipelineParams_valid;
  }

  //        enableStep() {
  //            let refName = 'describeSamples';
  //            (this.$refs[refName] as mdStep).mdActive = true;
  //            console.log("Enabled step " + refName);
  //
  //            this.dataSource_stepComplete = true;
  //        }

  async scrollToTop() {
    const topOfPage = { x: 0, y: 0 };
    const duration = 300; // ms
    return new Promise((resolve, reject) => {
      window.scrollTo({
        top: topOfPage.y,
        left: topOfPage.x,
        behavior: "smooth",
      });
      setTimeout(() => {
        resolve(topOfPage);
      }, duration);
    });
  }

  onExitStep(stepName: string) {
    if (stepName === "dataSource") {
      this.scrollToTop();
    } else if (stepName === "describeSamples") {
      (this.$refs["describeSamples_sampleCart"] as any).save();
      this.describeSamples_stepComplete = true;
      this.scrollToTop();
    } else if (stepName === "selectGenome") {
      this.scrollToTop();
    } else if (stepName === "pipelineSettings") {
      this.scrollToTop();
    }
  }

  async startJob() {
    try {
      this.start_job_button_enabled = false;
      const response = await (this.$refs["pipelineParams"] as any).run();
      if (response == null) {
        throw Error("Request to start job failed");
      }
      if (response && response.data && response.data.id) {
        this.$router.push({ name: "job", params: { jobId: response.data.id } });
      } else {
        this.$router.push("jobs");
      }
    } catch (error) {
      this.start_job_button_enabled = true;
      throw error;
    }
  }
}
